/* eslint-disable no-alert */
import ImageCompressor from 'image-compressor.js'
import firebase from 'firebase'
import path from 'path'

export default class ImageUpload {
  constructor(imageFile, filename, options) {
    const extension = imageFile.name.split('.').pop()
    const { originalUrl, destination, manipulation, type, firebaseSavePath, firestoreSavePath } = options

    this.file = imageFile
    this.name = `${filename}_${String(Date.now())}`
    this.extension = extension
    this.originalUrl = originalUrl || ''
    this.uploaded = false

    this.firebaseSavePath = firebaseSavePath || undefined
    this.firestoreSavePath = firestoreSavePath || undefined

    this.destination = destination
    this.manipulation = manipulation
    this.type = type

    const newFilename = `${this.name}.${this.extension}`
    this.filePath = path.join(this.destination, newFilename)
  }

  storageRef(savePath) {
    return firebase
      .storage()
      .ref()
      .child(savePath)
  }

  async upload() {
    try {
      const compressedFile = await this.compress(this.file)
      const snapshot = await this.storageRef(this.filePath).put(compressedFile)
      this.originalUrl = await snapshot.ref.getDownloadURL()
      this.uploaded = true

      const response = await this.createWebpVersion()
      const compressUrl = response ? response.data : null

      return { originalUrl: this.originalUrl, compressUrl }
    } catch (err) {
      return alert('There is problem while uploading file. Please try again.', err)
    }

  }

  compress(file) {
    const imageCompressor = new ImageCompressor()

    return imageCompressor.compress(file, { quality: 0.6 })
  }

  createWebpVersion() {
    const functions = firebase
      .app()
      .functions('asia-northeast1')
      .httpsCallable('compressImage')

    if (!this.firebaseSavePath) {
      return functions({
        name: this.name,
        type: this.type,
        url: this.originalUrl,
        destination: this.destination,
        manipulation: this.manipulation,
      })
    }

    functions({
      name: this.name,
      type: this.type,
      url: this.originalUrl,
      destination: this.destination,
      manipulation: this.manipulation,
      firebaseSavePath: this.firebaseSavePath,
    })

    return null
  }
}



// WEBPACK FOOTER //
// ./src/services/ImageUpload.js